import React from 'react';
import { trackCtaClick } from '../../../utils/gtm';
import { IconCircleCheck } from '../components/Icons';

const PACKAGES = [
  {
    id: 'starter',
    tier: 'Starter',
    title: 'Monthly bookkeeping for new & small companies',
    items: ['Monthly bookkeeping', 'Bank reconciliation', 'VAT-ready records', 'Monthly P&L'],
    cta: 'Get a quote',
  },
  {
    id: 'growth',
    tier: 'Growth',
    title: 'Full accounting services for growing SMEs',
    items: [
      'Everything in Starter',
      'Payables & receivables ageing',
      'Balance sheet + VAT position',
      'Corporate-tax-ready year-end pack',
      'Monthly review call',
    ],
    cta: 'Get my fixed quote',
    featured: true,
  },
  {
    id: 'catchup',
    tier: 'Catch-up',
    title: 'Backlog accounting & clean-up',
    items: ['Missed months rebuilt', 'Accounts reconciled', 'Clean handover into monthly', 'Fixed scope, fixed price'],
    cta: 'Get a quote',
  },
];

const PackagesSection = ({ onOpenModal }) => (
  <section className="bk-packages" id="packages" data-screen-label="Packages">
    <div className="bk-container">
      <header className="bk-packages-head">
        <h2 className="bk-h2 bk-h2--xl">Accounting &amp; bookkeeping packages in Dubai</h2>
        <p className="bk-lead">Fixed monthly fee, quoted after a 15-minute call. No lock-in.</p>
      </header>

      <div className="bk-packages-grid">
        {PACKAGES.map((pkg) => (
          <article key={pkg.id} className={`bk-package ${pkg.featured ? 'is-featured' : ''}`}>
            {pkg.featured && <span className="bk-package-badge">Most popular</span>}
            <span className="bk-package-tier">{pkg.tier}</span>
            <h3 className="bk-package-title">{pkg.title}</h3>
            <ul className="bk-package-list">
              {pkg.items.map((item) => (
                <li key={item}>
                  <IconCircleCheck size={17} />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
            <button
              type="button"
              className={`bk-btn bk-btn--block gtm-cta-btn ${pkg.featured ? 'bk-btn--orange' : 'bk-btn--outline'}`}
              data-gtm-id={`package-${pkg.id}-cta`}
              id={`package-${pkg.id}-cta`}
              onClick={() => {
                trackCtaClick(`package_${pkg.id}_get_quote`);
                onOpenModal(`${pkg.tier} package: ${pkg.title}`);
              }}
            >
              {pkg.cta}
            </button>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default PackagesSection;
